import { convertingSecondsToDeliveryStatus } from '@app/entities/Delivery';
import { PickUpShopsType } from '@app/features/fastOrder/module/types/fastOrderSchema';
import { formatPhone } from '@helpers/dateFormation';
import { formatDistance } from '@helpers/getDistance';
import { getTimeWork } from '@helpers/getTimeWork';
import { ShopsMapModelExt } from '@models/Header/IShopModel';
import { quantityLimitation } from '@shared/helpers';
import { MapBlockShopPropsType } from '@widgets/ui/Product/MapListShopsPickUpTodayProduct/MapBlockShop/MapBlockShop';
import { AvailableText } from './AvailableText';
import { PhoneCentre } from './PhoneCentre';
import { RecordText } from './RecordText';
import { TimeWorkText } from './TimeWorkText';
import { Rating } from './Rating';

export const BalloonContent = (shop, isMobile): string => {
  const { id, address, code, phone, timework, distance } = shop;

  if (isMobile) {
    return `
      <div class="wrapper__balloon">
        <div class="balloon__address mobile">${address}</div>
        <div class="balloon__distance">
          ${distance ? formatDistance(distance) : ''}
        </div>
        <div class="balloon__bottomBlock mobile">
           <a href="${code || ''}">
             <button type="button" class="map-button mobile" data-id="${id}">
                Перейти
             </button>
           </a>
          <div>
            ${PhoneCentre(phone)}
            <div class="balloon__timeWork mobile">
              ${getTimeWork(timework)}
            </div>
          </div>
        </div>
      </div>`;
  } else {
    return `
      <div class="wrapper__balloon">
        <div class="balloon__address">${address}</div>
         ${PhoneCentre(phone)}
        <div class="balloon__timeWork">
         ${getTimeWork(timework)}
        </div>
        <a href="${code || ''}">
         <button type="button" class="map-button" data-id="${id}">
            Перейти
         </button>
        </a>
      </div>`;
  }
};

export const BalloonOrderContent = (shop: ShopsMapModelExt): string => {
  const { id, address, phone, timeWork, available, record } = shop;
  return `
      <div class="wrapper__balloon">
        <div class="cart_balloon__address">
          <p>${address}</p>  
        </div>
        ${PhoneCentre(phone)}
        ${AvailableText(available)}
        ${RecordText(record)}
        ${TimeWorkText(timeWork)}
       <button type="button" class="map-button full order-map-button" data-id="${id}">
         Выбрать этот центр
       </button>
      </div>`;
};

export const BalloonCartProductContent = (shop: MapBlockShopPropsType): string => {
  const { distance, shopId, address, phone, timeWork, quantityNoToday, quantityToday, statusDeliveryToday, statusDeliveryNoToday } = shop;

  const availabilityText = `<div class="">
      <div>
        <div class="${quantityToday ? 'cart_balloon__place-pickers--in-stock hide_icon' : 'hide'}">
            ${quantityLimitation(quantityToday) || ''} шт.
            ${convertingSecondsToDeliveryStatus(statusDeliveryToday)}
        </div>
        <div class="${quantityNoToday ? '' : 'hide'}">
          ${quantityLimitation(quantityNoToday)} шт.
          ${convertingSecondsToDeliveryStatus(statusDeliveryNoToday)}
        </div>
      </div>    
    </div>`;

  const timeworkJSX = timeWork ? `<div class="balloon__timeWork">${timeWork}</div>` : '';

  return `
      <div class="wrapper__balloon max-w-300 padding-ui-kit mobile-width-full">
        <div class="cart_balloon__address">
          <p>${address}</p>
        </div>
        <div class="balloon__row">
        ${
          !distance
            ? ''
            : `<div class="balloon__distance iconDistance"><img src="/next/gimg/pageshop/icon-geo.svg"/> 
        ${formatDistance(distance)}</div>`
        }
          <div class="balloon__phone hide_icon">
            <a href="tel:${formatPhone(phone)}">
              ${formatPhone(phone)}
            </a>
          </div>
        </div>
        ${availabilityText}
        ${timeworkJSX}
       <button type="button" class="map-button full order-map-button" data-id="${shopId}">
         Забрать здесь
       </button>
      </div>`;
};

export const BalloonCartProductContentV2 = (shop: PickUpShopsType): string => {
  const {
    record,
    distance,
    shopId,
    address,
    yandexRating,
    yandexReviews,
    quantityNoToday,
    quantityToday,
    statusDeliveryToday,
    statusDeliveryNoToday,
  } = shop;

  const availabilityText = `<div class="">
      <div>
        <div class="${quantityToday ? 'cart_balloon__place-pickers--in-stock hide_icon' : 'hide'}">
            ${quantityLimitation(quantityToday) || ''} шт.
            ${convertingSecondsToDeliveryStatus(statusDeliveryToday)}
        </div>
        <div class="${quantityNoToday ? '' : 'hide'}">
          ${quantityLimitation(quantityNoToday)} шт.
          ${convertingSecondsToDeliveryStatus(statusDeliveryNoToday)}
        </div>
      </div>    
    </div>`;

  return `
      <div class="wrapper__balloon max-w-300 padding-ui-kit mobile-width-full">
        <div class="cart_balloon__address">
          <p>${address}</p>
        </div>
        <div class="balloon__row">
          ${
            distance
              ? `<div class="balloon__distance iconDistance">
                      <img src="/next/gimg/pageshop/distance.svg"/> 
                      ${formatDistance(distance)}
                    </div>`
              : ''
          }
        </div>
        <div class="balloon__row">
          ${Rating(yandexRating, +yandexReviews)}
        </div>
        ${availabilityText}
        ${RecordText(record)}
       <button type="button" class="map-button full order-map-button" data-id="${shopId}">
         Выбрать этот магазин
       </button>
      </div>`;
};
